import Badge from '../../WutBadge';

export default Badge;
